module.exports = __webpack_public_path__ + "img/firstEdition1.8d08db83.jpg";